import { createFileRoute } from '@tanstack/react-router'
import { SupplierReturnDetailPage } from '../../../../features/purchasing/return-pages'
import { documentActionSearchSchema } from '../../../../features/sales/document-action'

export const Route = createFileRoute('/_app/supplier-returns/$returnId/')({
  validateSearch: documentActionSearchSchema,
  component: SupplierReturnDetailPage,
})
